// Estado de las audiencias. ESPEJO de backend/src/lib/audiencias.ts, que es el
// que arma el historial: acá solo se decide qué se muestra y qué sale de la agenda.

export const ESTADOS_AUDIENCIA = ['Agendada', 'Realizada', 'Con continuación', 'Suspendida', 'Reprogramada'] as const;
export type EstadoAudiencia = (typeof ESTADOS_AUDIENCIA)[number];

/** Tipos para la continuación de una audiencia. */
export const TIPOS_CONTINUACION = ['Audiencia', 'C.A.P', 'C.A.J.', 'Otro'];

/** ¿Sigue en la agenda? Las suspendidas y reprogramadas no: su nueva fecha es otra audiencia. */
export const audienciaVigente = (a: any): boolean => !['Suspendida', 'Reprogramada'].includes(a?.estado);

export const estadoAudiencia = (a: any): EstadoAudiencia =>
  (ESTADOS_AUDIENCIA as readonly string[]).includes(a?.estado) ? a.estado : 'Agendada';

export const nuevoIdAudiencia = (): string =>
  typeof crypto !== 'undefined' && 'randomUUID' in crypto
    ? crypto.randomUUID()
    : 'n' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8);

/** La nueva audiencia con las mismas características que la original: se
 *  copia todo salvo lo que es propio de la original (id, estado, enlaces). */
export function audienciaReagendada(original: any, cambios: { tipo?: string; fecha: string; hora: string; lugar: string }, origen: string) {
  const { id, estado, motivo, reagendadaId, origenId, origen: _o, ...caracteristicas } = original || {};
  return { ...caracteristicas, ...cambios, tipo: cambios.tipo || original?.tipo, id: nuevoIdAudiencia(), origenId: id, origen };
}
